import { render, staticRenderFns } from "./ProvisionalRemedyDetail.vue?vue&type=template&id=7b44663d&scoped=true&"
import script from "./ProvisionalRemedyDetail.vue?vue&type=script&lang=js&"
export * from "./ProvisionalRemedyDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionalRemedyDetail.vue?vue&type=style&index=0&id=7b44663d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b44663d",
  null
  
)

export default component.exports